import React from 'react';
import { Icon } from '@iconify/react';
import { cn } from '@/lib/utils';

type IconProps = {
  className?: string;
};

export const AppleIcon: React.FC<IconProps> = ({ className }) => (
  <span className={cn('flex items-center', className)}>
    <Icon icon="simple-icons:apple" className="h-5 w-5 text-neutral-900 dark:text-neutral-100" />
  </span>
);

export const GoogleIcon: React.FC<IconProps> = ({ className }) => (
  <span className={cn('flex items-center', className)}>
    <Icon icon="simple-icons:google" className="h-5 w-5 text-[#4285F4]" />
  </span>
);

export const FacebookIcon: React.FC<IconProps> = ({ className }) => (
  <span className={cn('flex items-center', className)}>
    <Icon icon="simple-icons:facebook" className="h-5 w-5 text-[#1877F2]" />
  </span>
);

export const XIcon: React.FC<IconProps> = ({ className }) => (
  <span className={cn('flex items-center', className)}>
    <Icon icon="simple-icons:x" className="h-5 w-5 text-neutral-900 dark:text-neutral-100" aria-label="X" />
  </span>
);
